import { UserPreferences } from '../../store/User';
import { callExternalApi } from '../callExternalApi';

export const updateSettingsApi = async (
  settings: UserPreferences,
  type?: string,
  renamedViews?: Record<string, string>
) => {
  const params = type ? `?type=${type}` : '';
  return callExternalApi<UserPreferences>({
    url: `${process.env.REACT_APP_API_SERVER_URL}/api/preferences/user_customizations/${settings.id}${params}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(renamedViews ? { ...settings, renamed_views: renamedViews } : settings)
  });
};
